import { render, staticRenderFns } from "./table-dongtai.vue?vue&type=template&id=fb849944&scoped=true"
import script from "./table-dongtai.vue?vue&type=script&lang=ts"
export * from "./table-dongtai.vue?vue&type=script&lang=ts"
import style0 from "./table-dongtai.vue?vue&type=style&index=0&id=fb849944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb849944",
  null
  
)

export default component.exports